import { useMutation } from 'react-query';
import { updateRegisterResultReview } from 'apis/registerResult.api';

const useUpdateRegisterResultReviews = () => {
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: updateRegisterResultReview,
  });
  return { mutateAsync, ...rest };
};

export default useUpdateRegisterResultReviews;
